import { isEmpty } from 'lodash'

import api from 'utils/api'
import {
  GET_FILTERED_AND_PAGINATED_ATTENDANTS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_ATTENDANTS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_ATTENDANTS_FAILED,
  CREATE_ATTENDANT_WITH_ROLE_REQUESTED,
  CREATE_ATTENDANT_WITH_ROLE_SUCCEEDED,
  CREATE_ATTENDANT_WITH_ROLE_FAILED,
  UPDATE_ATTENDANT_WITH_ROLE_REQUESTED,
  UPDATE_ATTENDANT_WITH_ROLE_SUCCEEDED,
  UPDATE_ATTENDANT_WITH_ROLE_FAILED,
  UPDATE_ATTENDANT_REQUESTED,
  UPDATE_ATTENDANT_SUCCEEDED,
  UPDATE_ATTENDANT_FAILED,
} from './constants'

export const getAttendantsRequested = () => ({
  type: GET_FILTERED_AND_PAGINATED_ATTENDANTS_REQUESTED,
})

export const getAttendantsSucceeded = (payload) => ({
  type: GET_FILTERED_AND_PAGINATED_ATTENDANTS_SUCCEEDED,
  payload,
})

export const getAttendantsFailed = () => ({
  type: GET_FILTERED_AND_PAGINATED_ATTENDANTS_FAILED,
})

export const updateAttendantRequested = () => ({
  type: UPDATE_ATTENDANT_REQUESTED,
})

export const updateAttendantSucceeded = (payload) => ({
  type: UPDATE_ATTENDANT_SUCCEEDED,
  payload,
})

export const updateAttendantFailed = () => ({
  type: UPDATE_ATTENDANT_FAILED,
})

export const createAttendantWithRoleRequested = () => ({
  type: CREATE_ATTENDANT_WITH_ROLE_REQUESTED,
})

export const createAttendantWithRoleSucceeded = (payload) => ({
  type: CREATE_ATTENDANT_WITH_ROLE_SUCCEEDED,
  payload,
})

export const createAttendantWithRoleFailed = () => ({
  type: CREATE_ATTENDANT_WITH_ROLE_FAILED,
})

export const updateAttendantWithRoleRequested = () => ({
  type: UPDATE_ATTENDANT_WITH_ROLE_REQUESTED,
})

export const updateAttendantWithRoleSucceeded = (payload) => ({
  type: UPDATE_ATTENDANT_WITH_ROLE_SUCCEEDED,
  payload,
})

export const updateAttendantWithRoleFailed = () => ({
  type: UPDATE_ATTENDANT_WITH_ROLE_FAILED,
})

export const loadFilteredAndPaginatedAttendants =
  (params) => (dispatch) => {
    dispatch(getAttendantsRequested())

    return api
      .fetchFilteredAndPaginatedAttendants(params)
      .then((response) => dispatch(getAttendantsSucceeded(response)))
      .catch(() => dispatch(getAttendantsFailed()))
  }

export const updateAttendant = (data) => (dispatch) => {
  dispatch(updateAttendantRequested())

  return api
    .updateAttendant(data)
    .then((response) =>
      dispatch(updateAttendantSucceeded(response?.data?.attendants))
    )
    .catch(() => dispatch(updateAttendantFailed()))
}

export const createAttendantWithRole = (data) => async (dispatch) => {
  const { attendantData, roleData } = data

  await dispatch(createAttendantWithRoleRequested())

  const attendantRequest = await api.createAttendant(attendantData)
  const attendant = attendantRequest?.data?.attendants?.[0] ?? {}

  const roleRequest = await api.createEmployeeRole({
    ...roleData,
    employeeId: attendant?.employeeId,
  })
  const role = roleRequest?.data?.employeeRoles?.[0]?.role ?? ''

  const createdAttendant = {
    ...attendant,
    employeeRole: role,
  }

  await dispatch(createAttendantWithRoleSucceeded([createdAttendant]))
}

export const createAttendantsWithRolesInBulk =
  (data) => async (dispatch) => {
    dispatch(createAttendantWithRoleRequested())

    try {
      const attendants = await api.createAttendantsInBulk(data, {
        isToastDisabled: true,
      })

      dispatch(createAttendantWithRoleSucceeded(attendants))
    } catch (error) {
      dispatch(createAttendantWithRoleFailed())
      return error?.response?.data ?? []
    }
  }

export const updateAttendantWithRole = (data) => (dispatch) => {
  const { attendantData, roleData, uuid } = data

  dispatch(updateAttendantWithRoleRequested())

  const attendantPromise = !isEmpty(attendantData)
    ? api.updateAttendant(attendantData)
    : Promise.resolve()

  const rolePromise = !isEmpty(roleData)
    ? api
        .getEmployeeRole(uuid)
        .then((response) => {
          return api.deleteEmployeeRole(
            response?.data?.employeeRoles?.[0]?.uuid
          )
        })
        .then(() => {
          return api.createEmployeeRole(roleData)
        })
    : Promise.resolve()

  return Promise.all([attendantPromise, rolePromise])
    .then((response) => {
      const attendant = response[0]?.data?.attendants?.[0]
      const role = response[1]?.data?.employeeRoles?.[0]?.role

      const updatedAttendant = {
        ...attendant,
        employeeRole: role ? role : attendant?.employeeRole,
        uuid: uuid,
      }

      dispatch(updateAttendantWithRoleSucceeded([updatedAttendant]))
    })
    .catch(() => {
      dispatch(updateAttendantWithRoleFailed())
    })
}
